// extracted by mini-css-extract-plugin
module.exports = {"TitleWrapper":"TransformerDataComponent__TitleWrapper___3u4JV"};